import { SnackbarActionHandler } from './snackbar-action-handler';

export class SnackbarConfig {
  public actionHandler?: SnackbarActionHandler = null;
  public durationInMillis? = 3000;
  public status? = 'success';
}
